export const countTasksGroupByStatusService = (fetch) => async (filters) => {
  try {
    const searchParams = new URLSearchParams(filters).toString()
    const response = await fetch({
      url: '/api/v1/plan-trabajo-capacitacion/tareas/agrupado-por-estado?' + searchParams,
    })

    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message)
  }
}
